import React, { useState, useEffect, ReactNode, forwardRef } from 'react'
import styled from 'styled-components'


const HeaderContainer = styled.div`
  position: sticky;
  top: 64px;
  left: 0;
  z-index: 1000;
  padding: 10px 0;
  max-width: inherit;
  width: 100%;
  background-color: inherit;
`;

interface FixedHeaderProps {
  children: ReactNode
}

const FixedHeader = forwardRef<HTMLDivElement, FixedHeaderProps>(({ children }, ref) => {
  return (
    <HeaderContainer>
      <div ref={ref}>
        {children}
      </div>
    </HeaderContainer>
  )
})

export default FixedHeader